import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

import buildPath from '../utilities/buildPath';

type ThisApi = ApiDefinition['/questionnaire-templates/{slug}/questionnaires/template-version']['PUT'];
type Input = ThisApi['params'];
type Body = ThisApi['body'];

const upgradeAllUsingTemplate = async ({ slug }: Input, body: Body): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>('/questionnaire-templates/{slug}/questionnaires/template-version', { slug });
  const response = await formsBackendClient.put(path, body);
  return response.data;
};

export default upgradeAllUsingTemplate;
